import { Container, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { useGastos } from './hooks/useGastos';
import GastoForm from './GastoForm';
import GastosTable from './GastosTable';
import GastosResumen from './GastosResumen';

export default function LibroGastosApp() {
  const { gastos, agregarGasto, editarGasto, anularGasto } = useGastos();
  const [editing, setEditing] = useState(null);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        📕 Libro de Gastos
      </Typography>

      <GastosResumen gastos={gastos} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <GastoForm
            editing={editing}
            onSubmit={data => {
              editing
                ? editarGasto(editing.id, data)
                : agregarGasto(data);
              setEditing(null);
            }}
          />
        </Grid>

        <Grid item xs={12} md={8}>
          <GastosTable
            gastos={gastos}
            onEdit={setEditing}
            onAnular={anularGasto}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
